import { useQuery } from "@tanstack/react-query";
import {
  QuestionConfigDetailDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_QUESTION_DETAILS } from "../domain";

import { Error } from "@helpers";
import { questionsConfigApi } from "@api/services";
import { roleGuard } from "@api";

const allowedRoles = [UserRole.Admin, UserRole.Owner, UserRole.Manager];

const ACTION_GET_QUESTION_CONFIG_DETAILS = "ACTION_GET_QUESTION_CONFIG_DETAILS";

const fetchQuestionsConfigDetailsDetails = async (
  questionId: string,
): Promise<QuestionConfigDetailDto | undefined> => {
  try {
    const response =
      await questionsConfigApi.questionsConfigControllerGetQuestionConfigDetail(
        questionId,
      );

    const data = response.data;

    if (response.status === 200 && data) {
      return data;
    }
  } catch (error) {
    Error(error);
  }
};

export const useGetQuestionConfigDetails = (
  user: UserProfileDto | null,
  questionId: string,
  enable = true,
): {
  questionsConfigDetails?: QuestionConfigDetailDto;
  questionsConfigDetailsEnabled: boolean;
  isLoadingQuestionsConfigDetails: boolean;
  isFetchingQuestionsConfigDetails: boolean;
} => {
  const enabled = enable && roleGuard(user, allowedRoles);
  const { isLoading, isFetching, data } = useQuery({
    queryKey: [
      DOMAIN_QUESTION_DETAILS,
      ACTION_GET_QUESTION_CONFIG_DETAILS,
      questionId,
    ],
    queryFn: () => fetchQuestionsConfigDetailsDetails(questionId),
    enabled,
  });

  return {
    questionsConfigDetails: data,
    questionsConfigDetailsEnabled: enabled,
    isLoadingQuestionsConfigDetails: isLoading,
    isFetchingQuestionsConfigDetails: isFetching,
  };
};
